import { forwardRef } from "react";
import { fileUrl } from "@/lib/api";

const MembershipCard = forwardRef(({ member }, ref) => {
  if (!member) return null;
  return (
    <div ref={ref} data-testid="membership-card"
      className="relative w-full max-w-[400px] mx-auto rounded-2xl overflow-hidden text-white"
      style={{ background: "linear-gradient(160deg, #17111a 0%, #121019 50%, #0c0b10 100%)", border: "1px solid rgba(230,25,126,0.45)", boxShadow: "0 0 45px rgba(230,25,126,0.22), 0 0 70px rgba(33,182,230,0.12)" }}>
      <div className="absolute -top-16 -right-16 w-48 h-48 rounded-full bg-[#E6197E]/40 blur-3xl" />
      <div className="absolute -bottom-20 -left-16 w-52 h-52 rounded-full bg-[#21B6E6]/25 blur-3xl" />
      <div className="absolute top-1/3 left-1/4 w-32 h-32 rounded-full bg-[#F5A623]/15 blur-3xl" />

      <div className="relative px-5 pt-5 pb-3.5 flex items-center justify-between border-b border-white/10">
        <div className="flex items-center gap-2.5">
          <img src="/nasarawa-mark.png" alt="Nasarawa Expo" className="w-11 h-11 object-contain" />
          <div className="leading-none">
            <div className="font-heading font-extrabold text-base">NASARAWA EXPO</div>
            <div className="text-[10px] uppercase tracking-[0.22em] brand-text-gradient font-bold mt-1">Creative Member</div>
          </div>
        </div>
        <span className="text-[10px] font-bold uppercase tracking-widest text-emerald-400">Verified</span>
      </div>

      <div className="relative px-5 py-4 flex gap-4">
        <div className="w-32 h-40 rounded-lg overflow-hidden bg-zinc-800 shrink-0 ring-2 ring-[#E6197E]/60">
          {member.photo_path ? (
            <img src={fileUrl(member.photo_path)} alt={member.full_name} className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full flex items-center justify-center text-5xl font-heading text-zinc-500">{member.full_name?.[0]}</div>
          )}
        </div>
        <div className="min-w-0 flex-1 flex flex-col justify-center">
          <div className="font-heading font-extrabold text-2xl leading-none break-words">{member.full_name}</div>
          <div className="mt-2 inline-block self-start text-xs font-bold px-2.5 py-1 rounded bg-[#21B6E6]/20 text-[#5CCBF0]">{member.lga} LGA</div>
          <div className="mt-4 text-[11px] text-zinc-400 uppercase tracking-widest font-semibold">Discipline</div>
          <div className="text-lg font-semibold leading-tight">{member.discipline}</div>
          <div className="text-base text-[#F5A623] font-bold leading-tight">{member.expertise}</div>
        </div>
      </div>

      <div className="relative px-5 pb-5 pt-1 flex items-end justify-between">
        <div>
          <div className="text-[11px] text-zinc-400 uppercase tracking-widest font-semibold">Membership ID</div>
          <div className="font-mono-accent text-xl text-white tracking-wide mt-0.5">{member.membership_id}</div>
          <div className="text-[11px] text-zinc-500 mt-2">Scan to verify membership</div>
        </div>
        {member.qr && (
          <div className="bg-white p-2 rounded-lg" data-testid="membership-card-qr-code">
            <img src={member.qr} alt="QR code" className="w-24 h-24" />
          </div>
        )}
      </div>
    </div>
  );
});

MembershipCard.displayName = "MembershipCard";
export default MembershipCard;
